import GenericTabComponent from "../../components/GenericTabComponent";
import About from "./Tabs/About";

export default function ESports2026() {
  const content = [
    { label: "विषय", component: <About /> },
  ];
  const pagetitle = "बिहार स्टेट ओपन ई-स्पोर्ट्स चैंपियनशिप 2026",
    desktopBanner = "/img/esports2026-banner.png",
    mobileBanner = "/img/esports2026-mobile.png";
  return (
    <>
      <GenericTabComponent
        content={content}
        desktopBanner={desktopBanner}
        mobileBanner={mobileBanner}
        pageTitle={pagetitle}
      />
    </>
  );
}
